import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useMutation } from 'react-query';

const disconnectPodium = async (): Promise<void> => {
  const response = await EXPRESS_API.post(`/podium/disconnect`);
  return response.data;
};

export const usePodiumDisconnectMutation = () => {
  return useMutation<void, Error, void>(disconnectPodium, {
    onSuccess: () => {
      successToast({ title: 'Podium disconnected!' });
    },
  });
};
